/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook"
import { AllFacilitiesList } from "../../redux/Slice/Facilities/FacilitiesListSlice"
import { AllSportsList } from "../../redux/Slice/Sports/SportsListSlice"
import { GetStates } from "../../redux/Slice/Users/StateListSlice"
import { GetEnumsArr } from "../../redux/Slice/Users/EnumsSclice"
import { AllCourtsList } from "../../redux/Slice/Courts/CourtsListSlice"
import { useNavigate } from "react-router-dom"
import { format } from "date-fns"
import { GetSettings } from "../../redux/Slice/Settings/SettingSlice"
import { GetBookingSummarySportWise, GetBookingSummaryTypewise, GetDashboardCount } from "../../utilities/api/dashboard"
import { Card, Col, Container, Row } from "react-bootstrap"
import { images } from "../../config/images"
import DatePicker from "react-multi-date-picker"
import InputIcon from "react-multi-date-picker/components/input_icon"
import { Button } from "../../components"
import Chart from "react-apexcharts";
import { toast } from "react-toastify";
const OfficeAdminDashboard = () => {
    const { SelectedFacility } = useAppSelector(state => state.facilityList)
    const { setting, errorMessage } = useAppSelector(state => state.settings)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [defaultPeriod, setDefaultPeriod] = useState(localStorage.getItem("dashboard-default-date") ? localStorage.getItem("dashboard-default-date") : "weekly")
    const defaultTd = format(new Date(), "yyyy-MM-dd")

    const [dashboardCount, setDeshboardCount] = useState({
        totalCourts: 0,
        totalSports: 0,
    })
    if (errorMessage) {
        toast.error(errorMessage.message)
    }
    const getDefaultFd = () => {

        const currentDate = new Date();
        let calculatedFromDate = new Date();

        const formatDate = (FDate: any) => {
            const day = String(FDate.getDate()).padStart(2, '0');
            const month = String(FDate.getMonth() + 1).padStart(2, '0');
            const year = FDate.getFullYear();
            return `${year}-${month}-${day}`;
        };

        switch (defaultPeriod) {
            case 'weekly':
                calculatedFromDate.setDate(currentDate.getDate() - 7);
                break;
            case 'monthly':
                calculatedFromDate.setMonth(currentDate.getMonth() - 1);
                break;
            case 'yearly':
                calculatedFromDate.setFullYear(currentDate.getFullYear() - 1);
                break;
            default:
                calculatedFromDate = currentDate;
                break;
        }
        return formatDate(calculatedFromDate)
    }

    const [date, setDate] = useState({
        liveBookingFd: getDefaultFd(),
        liveBookingTd: defaultTd,
        sportwiseBookingFd: getDefaultFd(),
        sportwiseBookingTd: defaultTd,
    })

    let initialState = {
        series: [25, 25, 25, 25],
        options: { labels: [] },
        legend: { show: false }
    };
    const [livebooking, setLiveBooking] = useState({ ...initialState })
    const [sportWiseBooking, setSportWiseBooking] = useState({ ...initialState })
    const [emptyData, setEmptyData] = useState({ liveBooking: false, sportwiseBooking: false })

    useEffect(() => {
        dispatch(GetSettings())
        GetCount()
        dispatch(AllSportsList({ isActive: "true" }))
        dispatch(GetStates())
        dispatch(AllFacilitiesList("true"))
        dispatch(GetEnumsArr())
        dispatch(AllCourtsList({}))
        if (!localStorage.getItem("dashboard-default-date")) {
            localStorage.setItem("dashboard-default-date", "weekly")
        }
    }, [])

    useEffect(() => {
        GetLiveBooking()
        GetSportwiseBooking()
    }, [SelectedFacility])

    useEffect(() => {
        setDefaultPeriod(setting?.dashboardDefaultInterval)
        localStorage.setItem("dashboard-default-date", setting?.dashboardDefaultInterval)
    }, [setting])

    const GetCount = async () => {
        const result = await GetDashboardCount()
        if (result.statusCode === 200) {
            let data = result.data.countsData
            setDeshboardCount({
                totalCourts: data.totalCourts,
                totalSports: data.totalSports,
            })
        }
    }

    const GetLiveBooking = async () => {
        let result = await GetBookingSummaryTypewise(date.liveBookingFd, date.liveBookingTd, SelectedFacility)
        if (result.statusCode === 200) {
            const isEmpty = !result.data.summaryData?.length;
            setEmptyData((old) => ({ ...old, liveBooking: isEmpty }));
            setLiveBooking({
                ...livebooking,
                series: result.data.summaryData?.map((item: any) => item.count),
                options: { labels: result.data.summaryData?.map((item: any) => item.typeName) },
            })
        }
    }

    const GetSportwiseBooking = async () => {
        const result = await GetBookingSummarySportWise(date.sportwiseBookingFd, date.sportwiseBookingTd, SelectedFacility)
        if (result.statusCode === 200) {
            const isEmpty = !result.data.summaryData?.length;
            setEmptyData((old) => ({ ...old, sportwiseBooking: isEmpty }));
            setSportWiseBooking({
                ...sportWiseBooking,
                series: result.data.summaryData?.map((item: any) => item.count),
                options: { labels: result.data.summaryData?.map((item: any) => item.sportName) },
            })
        }
    }

    return (
      <>
        <Container fluid className="g-0">
          <Row className="row-mb g-4 align-items-center">
            <Col lg={4}>
              <Card className="shadow-sm count-card">
                <Card.Body>
                  <div className="card-text">Total Sports</div>
                  <div className="card-count">{dashboardCount.totalSports}</div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="shadow-sm count-card">
                <Card.Body>
                  <div className="card-text">Total Courts</div>
                  <div className="card-count">{dashboardCount.totalCourts}</div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="shadow-sm count-card mb-1" onClick={() => navigate("/exit-booking")}>
                <Card.Body className="padding-14">
                  <div className="align-items-center card-text d-flex justify-content-center">
                    <span className="icon-exit-booking me-2"></span> Exit Booking
                  </div>
                </Card.Body>
              </Card>
              <Card
                className="shadow-sm count-card"
                onClick={() => navigate("/facility-availability-check")}
              >
                <Card.Body className="padding-14">
                  <div className="align-items-center card-text d-flex justify-content-center">
                    <span className="icon-facilities me-2"></span> Availability Check
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="g-4">
            <Col lg={6}>
              <Card className="shadow-sm">
                <img
                  alt=""
                  src={images.refereshchart.default}
                  width={30}
                  className="refresh-chart"
                  onClick={() => GetLiveBooking()}
                />
                <Card.Body>
                  <Card.Title className="text-start mb-3">Live Booking</Card.Title>
                  <Row className="row-mb">
                    <Col lg={6} className="text-start">
                      <label className="form-label d-block"> From Date : </label>
                      <DatePicker
                        onChange={(e: any) =>
                          setDate({ ...date, liveBookingFd: e?.format("YYYY-MM-DD") })
                        }
                        value={date.liveBookingFd?.split("-").reverse().join("-")}
                        format="DD-MM-YYYY"
                        render={<InputIcon className="form-control form-control-sm h-auto" />}
                      />
                    </Col>
                    <Col lg={6} className="text-start">
                      <label className="form-label d-block"> To Date : </label>
                      <DatePicker
                        onChange={(e: any) =>
                          setDate({ ...date, liveBookingTd: e?.format("YYYY-MM-DD") })
                        }
                        value={date.liveBookingTd?.split("-").reverse().join("-")}
                        format="DD-MM-YYYY"
                        render={
                          <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                        }
                      />
                      <Button
                        onClick={() => GetLiveBooking()}
                        disabled={
                          date.liveBookingFd?.length !== 10 || date.liveBookingTd?.length !== 10
                        }
                        type="button"
                        bname="Go"
                        name="Go-button"
                        id="go-button"
                        className="btn btn-primary btn-sm rounded-1"
                      />
                    </Col>
                  </Row>
                  <div className="donut" style={{ height: "270px" }}>
                    {emptyData.liveBooking ? (
                      <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                        No data found
                      </div>
                    ) : (
                      <Chart
                        options={livebooking.options}
                        series={livebooking.series}
                        type="pie"
                        height="100%"
                      />
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6}>
              <Card className="shadow-sm">
                <img
                  alt=""
                  src={images.refereshchart.default}
                  width={30}
                  className="refresh-chart"
                  onClick={() => GetSportwiseBooking()}
                />
                <Card.Body>
                  <Card.Title className="text-start mb-3">Sport-Wise Booking</Card.Title>
                  <Row className="row-mb">
                    <Col lg={6} className="text-start">
                      <label className="form-label d-block"> From Date : </label>
                      <DatePicker
                        onChange={(e: any) =>
                          setDate({ ...date, sportwiseBookingFd: e?.format("YYYY-MM-DD") })
                        }
                        value={date.sportwiseBookingFd?.split("-").reverse().join("-")}
                        format="DD-MM-YYYY"
                        render={<InputIcon className="form-control form-control-sm h-auto" />}
                      />
                    </Col>
                    <Col lg={6} className="text-start">
                      <label className="form-label d-block"> To Date : </label>
                      <DatePicker
                        onChange={(e: any) =>
                          setDate({ ...date, sportwiseBookingTd: e?.format("YYYY-MM-DD") })
                        }
                        value={date.sportwiseBookingTd?.split("-").reverse().join("-")}
                        format="DD-MM-YYYY"
                        render={
                          <InputIcon className="border-end-0 form-control form-control-sm h-auto" />
                        }
                      />
                      <Button
                        onClick={() => GetSportwiseBooking()}
                        disabled={
                          date.sportwiseBookingFd?.length !== 10 ||
                          date.sportwiseBookingTd?.length !== 10
                        }
                        type="button"
                        bname="Go"
                        name="Go-button"
                        id="go-button"
                        className="btn btn-primary btn-sm rounded-1"
                      />
                    </Col>
                  </Row>
                  <div className="donut" style={{ height: "270px" }}>
                    {emptyData.sportwiseBooking ? (
                      <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                        No data found
                      </div>
                    ) : (
                      <Chart
                        options={sportWiseBooking.options}
                        series={sportWiseBooking.series}
                        type="pie"
                        height="100%"
                      />
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <br />
        </Container>
      </>
    );
}

export { OfficeAdminDashboard }
